// extracted by mini-css-extract-plugin
module.exports = {"table":"MsaOptions_table__1RefG","colHead":"MsaOptions_colHead__2m-lL","colMinPrice":"MsaOptions_colMinPrice__1LIm4","colTargetPrice":"MsaOptions_colTargetPrice__3lJqd"};